import { useState, useRef, useEffect } from 'react'
import menuIcon from 'assets/icons/menu.svg'
import clsx from 'clsx'
import './dots-menu.scss'

const DotsMenu = ({ children, size = 20, containerClass }) => {
  const dropdownRef = useRef(null)
  const [open, setOpen] = useState(false)

  useEffect(() => {
    const { current } = dropdownRef
    if (current) {
      const items = current.querySelectorAll('.item')
      if (items && items.length > 0) {
        items.forEach((item) => {
          item.addEventListener('click', () => {
            setOpen(false)
          })
        })
      }
    }
  }, [dropdownRef])

  const handleOnClick = () => {
    setOpen(!open)
  }

  const handleOnBlur = () => {
    setTimeout(() => {
      if (!dropdownRef.current.contains(document.activeElement)) {
        setOpen(false)
      }
    }, 0)
  }

  return (
    <div
      className={`dots-menu relative w-[20px] ${containerClass}`}
      onBlur={handleOnBlur}
      ref={dropdownRef}
      onClick={(e) => e.stopPropagation()}
    >
      <button
        onClick={handleOnClick}
        className="flex align-center justify-center w-full"
      >
        <img
          style={{ height: `${size}px` }}
          src={menuIcon}
          alt="Dropdown menu"
        />
      </button>
      <div
        className={clsx(
          'absolute top-full right-full bg-gray-light drop-shadow-dark rounded overflow-hidden dots-menu-menu',
          { hidden: !open },
        )}
      >
        {children}
      </div>
    </div>
  )
}

export default DotsMenu
